module.exports = __webpack_public_path__ + "assets/img/img243.d72158c9.png";